import React from "react";
import bSthil1 from '../img/sthil/banner/img1.jpg'
import bSthil2 from '../img/sthil/banner/img2.jpg'
import bConstrucao1 from '../img/construcao/banner/img1.png'
import bConstrucao2 from '../img/construcao/banner/img2.jpeg'
import bConstrucao3 from '../img/construcao/banner/img3.png'
import bMercado1 from '../img/mercado/banner/img1.png'
import bMercado2 from '../img/mercado/banner/img2.png'
import bMercado3 from '../img/mercado/banner/img3.png'
import { height } from "@fortawesome/free-brands-svg-icons/fa42Group";

export const BannerSeguimento = () => {


    return (

        <div style={{height:'10%'}}>

            <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                <img src={bSthil1} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bSthil2} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bConstrucao1} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bConstrucao2} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bConstrucao3} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bMercado1} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bMercado2} class="d-block w-100" alt="..."/>
                </div>
                <div class="carousel-item">
                <img src={bMercado3} class="d-block w-100" alt="..."/>
                </div>
            </div>
            </div>
        </div>
    )


}